The availability of a candidate for a new position.
